import React from 'react'
import { Button, colors, spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { type FeatureHighlight } from './types'

interface FeatureEducationSlideLayoutProps {
  feature: FeatureHighlight
  nextFeature?: FeatureHighlight
  isLastFeature: boolean
  onNextFeature: () => void
}

const Root = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
})

const ImageWrapper = styled('div')({
  borderRadius: spacing.X8,
  background: colors.SECONDARY.LIGHT,
  padding: spacing.X8,
  marginRight: spacing.X20,
  flex: 1,
})

const FeatureEducationSlideLayoutBody = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
})

const StyledMarkdownWrapper = styled('div')({
  overflow: 'scroll',
  marginBottom: spacing.X8,
  flex: 1,
})

const Image = styled('img')({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
})

const FeatureEducationSlideLayout = ({
  feature,
  nextFeature,
  isLastFeature,
  onNextFeature,
}: FeatureEducationSlideLayoutProps) => {
  const { img, Component } = feature

  return (
    <Root>
      <ImageWrapper>
        <Image src={img} />
      </ImageWrapper>
      <FeatureEducationSlideLayoutBody>
        <StyledMarkdownWrapper>
          <Component />
        </StyledMarkdownWrapper>
        <Button onClick={onNextFeature}>
          {isLastFeature ? 'Dismiss' : `Next: ${nextFeature?.name}`}
        </Button>
      </FeatureEducationSlideLayoutBody>
    </Root>
  )
}

export default FeatureEducationSlideLayout
